import clsx from 'clsx'

type TagVariant = 'primary' | 'secondary' | 'live'

export const Tag = ({variant, children}: {variant: TagVariant; children: React.ReactNode}) => {
  const isLive = variant === 'live'

  return (
    <span
      className={clsx(
        'flex h-[22px] items-center rounded-4 px-2 text-10 font-semibold uppercase leading-4 tracking-wide',
        {
          'bg-moss-blue text-moss-white': variant === 'primary',
          'bg-moss-blue-light text-moss-blue': variant === 'secondary',
          'gap-1 bg-[#6BBC00] text-moss-white': isLive,
        },
      )}
    >
      {isLive && <span className="size-1.5 animate-pulse rounded-full bg-moss-white" aria-hidden="true" />}
      {children}
    </span>
  )
}
